import useIsMounted from 'ismounted'
import { useCallback, useState } from 'react'

export const useLoading = <F extends (...args: any) => any>(func: F): [F, boolean] => {
  const [loading, setLoading] = useState(false)
  const isMounted = useIsMounted()

  const decoratedFunc = useCallback(
    async (...originalParams: any[]) => {
      try {
        setLoading(true)
        const result = await func(...originalParams)
        if (isMounted.current) setLoading(false)

        return result
      } finally {
        if (isMounted.current) setLoading(false)
      }
    },
    [isMounted, func],
  ) as F

  return [decoratedFunc, loading]
}
